<!--
component: KamiInformationInput
author: Izumi
description: 台帳情報入力画面
-->
<template>
	<body style="height: 100%;">

		<!-- データ入力時の台帳参照ウィンドウ -->
		<container class="scroll-container" style="width: 100%; height: calc(100% - 444px);">
			<div class="scroll-container" ref="container" @wheel.prevent="handleWheel" style="width: 100%; height: 100%;">
				<div class="image-wrapper" :style="{ transform: `translate(${translateX}px, ${translateY}px) scale(${scale})` }" style="width: 100%; height: 100%;">
					<img :src="imageUrl" alt="Image" class="full-width-image" ref="image" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp" @mouseleave="handleMouseUp">
				</div>
			</div>
		</container>

		<!-- 操作・入力項目 -->
		<div style="align-items: flex-end;">	
			<!-- 操作ボタン -->
			<container class="button-container">
        <div class="button-container">
          <input type="radio" id="市台帳" name="data-book" v-model="selectedDataBook" value="1" class="input-hidden" @click="dispKubunImageData(1)" :disabled="!isShiDaicho"/>
          <label for="市台帳" class="action-button" :disabled="!isShiDaicho">市台帳</label>

          <input type="radio" id="区台帳" name="data-book" v-model="selectedDataBook" value="2" class="input-hidden" @click="dispKubunImageData(2)" :disabled="!isKuDancho"/>
          <label for="区台帳" class="action-button" :disabled="!isKuDancho">区台帳</label>

          <input type="radio" id="計通台帳" name="data-book" v-model="selectedDataBook" value="3" class="input-hidden" @click="dispKubunImageData(3)" :disabled="!iskeiDaicho"/>
          <label for="計通台帳" class="action-button" :disabled="!iskeiDaicho">計通台帳</label>

          <input type="radio" id="分区台帳" name="data-book" v-model="selectedDataBook" value="4" class="input-hidden" @click="dispKubunImageData(4)" :disabled="!isBunDaicho"/>
          <label for="分区台帳" class="action-button" :disabled="!isBunDaicho">分区台帳</label>

          <input type="radio" id="概要書" name="data-book" v-model="selectedDataBook" value="5" class="input-hidden" @click="dispKubunImageData(5)" :disabled="!isGaiyosho"/>
          <label for="概要書" class="action-button" :disabled="!isGaiyosho">概要書</label>
        </div>
<!--
				<div class="button-container">
					<button class="action-button" @click="dispKubunImageData(1)" :disabled="!isShiDaicho">
						市台帳
					</button>
					<button class="action-button" @click="dispKubunImageData(2)" :disabled="!isKuDancho">
						区台帳
					</button>
					<button class="action-button" @click="dispKubunImageData(3)" :disabled="!iskeiDaicho">
						計通台帳
					</button>
					<button class="action-button" @click="dispKubunImageData(4)" :disabled="!isBunDaicho">
						分区台帳
					</button>
					<button class="action-button" @click="dispKubunImageData(5)" :disabled="!isGaiyosho">
						概要書
					</button>
				</div>
-->
				<div class="button-container">
					<button class="action-button" @click="goto_before_image" :disabled="!isBeforeImage">
						前画像
					</button>
					<button class="action-button" @click="goto_next_image" :disabled="!isNextImage">
						次画像
					</button>
				</div>

				<div class="button-container-right">
					<div style="margin-right: 5px;"> {{currentFileName}} </div>
					<button class="action-button" @click="toggleFullScreen">
						全画面表示
					</button>
					<div style="margin-right: 5px;">
						<button class="action-button" @click="rotateLeft">
							左回転
						</button>
						<button class="action-button" @click="rotateRight">
							右回転
						</button>
					</div>
					<button class="action-button" @click="printImage">
						画像印刷
					</button>
				</div>
			</container>

			<!-- 入力フォーム１段目 -->
			<container style="width: 100%; margin-bottom: 5px; align-items: center;">

				<div style="display: flex; align-items: center;">
					<input type="textbox" v-model="sikibetsu" style="height: 42px; width: 260px; background-color: #ffffd6; text-align: center; font-size: 34px; font-weight: bold;" disabled> 
				</div>

				<div class="right-align-container" style="display: flex; align-items: center;">
					<div style="margin-right: 20px;">
						<label>
							<input class="checkbox" type="checkbox" id="showMessage" v-model="flg_data_kakutei" name="flg_data_kakutei" 
							:disabled="isReadOnly">
							データ確定識別
						</label>
					</div>
					<div>
						<label>
							<input class="checkbox" type="checkbox" id="showMessage" v-model="flg_data_kknnzumi" name="flg_data_kknnzumi" 
							:disabled="isReadOnly || !flg_data_kakutei">
							データ確認済識別
						</label>
					</div>
				</div>

			</container>

			<!-- 入力フォーム2段目 -->
			<container style="width: 100%; margin-bottom: 10px;">
				<section style="width: 15%;">
					<p>受付年月日</p>
					<!--
					<input class="textbox" type="date" v-model="uke_day" name="uke_day" id="dateInput" v-bind:readonly="isReadOnly">
					-->
					<DatePicker ref="cnfUkeDate" v-model="uke_day" @clear="uke_day_from = $event"
																:active="isReadOnly"/>

					<p>確認年月日</p>
					<!--
					<input class="textbox" type="date" v-model="kknn_day" name="kknn_day" id="dateInput" v-bind:readonly="isReadOnly">						
					-->
					<DatePicker ref="cnfKknnnDate" v-model="kknn_day" @clear="uke_day_from = $event"
																:active="isReadOnly"/>
				</section>

				<section style="width:55%;">
					<container style="width:100%;">
						<section style="width:50%;">
							<p>建築主住所</p>
							<input ref="bldr_addr1" class="textbox" type="text" v-model="bldr_addr1" name="bldr_addr1" id="textInput" v-bind:readonly="isReadOnly" style="ime-mode: active;">
							<input class="textbox" type="text" v-model="bldr_addr2" name="bldr_addr2" id="textInput" v-bind:readonly="isReadOnly" style="ime-mode: active;">
						</section>
						<section style="margin-right: 0px; width:50%;">
							<p>建築主氏名</p>
							<input class="textbox" type="text" v-model="bldr_name1" name="bldr_name1" id="textInput" v-bind:readonly="isReadOnly" style="ime-mode: active;">
							<container style="width:100%;">
								<input class="textbox" type="text" v-model="bldr_name2" name="bldr_name2" id="textInput" v-bind:readonly="isReadOnly" style="ime-mode: active; margin-right:5px;">
								<div style="min-width: 62px;">
									他<input class="textbox" type="text" v-model="bldr_other_cnt" name="bldr_other_cnt" id="textInput"
									@input="floorInput('bldr_other_cnt')" style="width: 33px; ime-mode: inactive;" v-bind:readonly="isReadOnly">名
								</div>
							</container>
						</section>
					</container>
					<section style="width:100%;">
						<p>物件所在地</p>
						<container style="width:100%;">
							<input class="textbox" type="text" v-model="bkn_addr1" name="bkn_addr1" id="textInput"
								style="margin-right: 5px; ime-mode: active;" v-bind:readonly="isReadOnly">
							<input class="textbox" type="text" v-model="bkn_addr2" name="bkn_addr2" id="textInput"
								style="ime-mode: active;" v-bind:readonly="isReadOnly">
						</container>
					</section>
				</section>

				<section style="width: 15%;">
					<p>主要用途</p>
						<input class="combob" style="width: 100%; ime-mode: active;" type="text" list="usage" placeholder="入力または選択"  autocomplete="off" v-model="syuyo_yoto" :disabled="isReadOnly">
						<datalist id="usage">
							<option value="専用住宅">専用住宅</option>
							<option value="共同住宅">共同住宅</option>
							<option value="住宅">住宅</option>
							<option value="長屋">長屋</option>
							<option value="事務所">事務所</option>
							<option value="店舗">店舗</option>
							<option value="事務所併用住宅">事務所併用住宅</option>
							<option value="店舗併用住宅">店舗併用住宅</option>
							<option value="工場">工場</option>
							<option value="倉庫">倉庫</option>
							<option value="物置">物置</option>
							<option value="その他">その他</option>
						</datalist>
					

					<div class="custom-select" style="width: 100%; ime-mode: active;">
						<select v-model="bkn_sybt" name="bkn_sybt" :disabled="isReadOnly">
							<option value="建築物">建築物</option>
							<option value="擁壁">擁壁</option>
							<option value="昇降機等">昇降機等</option>
							<option value="看板等">看板等</option>
							<option value="その他工作物">その他工作物</option>
						</select>
					</div>

					<p>工事種別</p>
					<div class="combob" style="width: 100%;">
						<input class="custom-select" style="width: 100%; ime-mode: active;" type="text" list="koji_list" placeholder="入力または選択"  autocomplete="off" v-model="koji_sybt" :disabled="isReadOnly">
						<datalist id="koji_list">
							<option value="新築">新築</option>
							<option value="増築">増築</option>
							<option value="改築">改築</option>
							<option value="移転">移転</option>
							<option value="用途変更">用途変更</option>
						</datalist>
					</div>
				</section>

				<section style="width: 15%; padding-right:0px;">
					<p>構造</p>
						<input class="combob" style="width: 100%; ime-mode: active;" type="text" list="kozo_list" placeholder="入力または選択"  autocomplete="off" v-model="kozo_sybt" :disabled="isReadOnly">
						<datalist id="kozo_list">
							<option value="木造">木造</option>
							<option value="鉄骨造">鉄骨造</option>
							<option value="ＲＣ造">ＲＣ造</option>
							<option value="ＳＲＣ造">ＳＲＣ造</option>
							<option value="防火構造">防火構造</option>
							<option value="簡易耐火(イ)構造">簡易耐火(イ)構造</option>
							<option value="簡易耐火(ロ)構造">簡易耐火(ロ)構造</option>
							<option value="耐火構造">耐火構造</option>
						</datalist>
					
					<container style="align-items: flex-end;">
						<section>
							<div style="display: flex; align-items: center;">
								<label style="margin-right: 5px; ime-mode: inactive;">地上</label>
								<input class="textbox" type="text" v-model="tijo_kaisu" name="tijo_kaisu"
									@input="floorInput('tijo_kaisu')" style="width: 40px; margin-right: 5px;" v-bind:readonly="isReadOnly">
								<label style="margin-right: 5px; ime-mode: inactive;">階</label>
							</div>
							<div style="display: flex; align-items: center;">
								<label style="margin-right: 5px; ime-mode: inactive;">地下</label>
								<input class="textbox" type="text" v-model="tika_kaisu" name="tika_kaisu"
									@input="floorInput('tika_kaisu')" style="width: 40px; margin-right: 5px;" v-bind:readonly="isReadOnly">
								<label>階</label>
							</div>
							<div style="display: flex; align-items: center;">
								<label style="margin-right: 5px; ime-mode: inactive;">棟数</label>
								<input class="textbox" type="text" v-model="sns_bld_su" name="sns_bld_su"
									@input="floorInput('sns_bld_su')" style="width: 40px;" v-bind:readonly="isReadOnly">
							</div>
						</section>

					</container>
				</section>
			</container>

			<!-- 入力フォーム3段目 -->
			<container style="width:100%; margin-bottom: 3px;">
				<section style="width:15%;">
					<p>敷地面積</p>
					<div style="display: flex; align-items: center;">
						<input class="textbox" type="text" v-model="site_area" name="site_area" id="textInput"
						@input="floorEreaInput('site_area')" style="width: 80%; text-align: right; ime-mode: inactive;" v-bind:readonly="isReadOnly">
						<div class="custom-select" style="width: 20%-7px;">
							<select v-model="unit_site_area" name="unit_site_area" :disabled="isReadOnly">
								<option value="㎡">㎡</option>
								<option value="坪">坪</option>
							</select>
						</div>
					</div>

					<p>建築面積</p>
					<div style="display: flex; align-items: center;">
						<input class="textbox" type="text" v-model="bld_area" name="bld_area" id="textInput"
						@input="floorEreaInput('bld_area')" style="width: 80%; text-align: right; ime-mode: inactive;" v-bind:readonly="isReadOnly">
						<div class="custom-select" style="width: 20%-7px;">
							<select v-model="unit_bld_area" name="unit_bld_area" :disabled="isReadOnly">
								<option value="㎡">㎡</option>
								<option value="坪">坪</option>
							</select>
						</div>
					</div>

					<p>延べ面積</p>
					<div style="display: flex; align-items: center;">
						<input class="textbox" type="text" v-model="nb_area" name="nb_area" id="textInput"
						@input="floorEreaInput('nb_area')" style="width: 80%; text-align: right; ime-mode: inactive;" v-bind:readonly="isReadOnly">
						<div class="custom-select" style="width: 20%-7px;">
							<select v-model="unit_nb_area" name="unit_nb_area" :disabled="isReadOnly">
								<option value="㎡">㎡</option>
								<option value="坪">坪</option>
							</select>
						</div>
					</div>
				</section>

				<section style="width: 20%;">
					<p>検査済証交付年月日</p>
					<container style="align-items: center;">
						<div style="margin-right: 5px">
							<DatePicker ref="cnfKenzumiDate" v-model="kenzumi_day" @clear="uke_day_from = $event"
																	:active="isReadOnly || flg_kenzumi"/>
						</div>
						<div>
							<label style="display: flex; align-items: center">
								<input type="checkbox" v-model="flg_kenzumi" name="flg_kenzumi" id="showMessage" class="checkbox" :disabled="isReadOnly">
								記載なし
							</label>
						</div>
					</container>
					<p>取下げ・取止め等</p>
					<container style="align-items: center;">
						<div class="custom-select" style="width: 40%; margin-right: 5px; ime-mode: inactive;">
							<select v-model="stop_sybt" name="stop_sybt" :disabled="isReadOnly">
								<option value="0"></option>
								<option value="1">取下</option>
								<option value="2">取止</option>
								<option value="3">未確</option>
								<option value="4">不適合</option>
							</select>
						</div>
						<div style="margin-right: 0px">
							<DatePicker ref="cnfStopDate" v-model="stop_day" @clear="uke_day_from = $event"
																:active="isReadOnly"/>
						</div>
					</container>
				</section>

				<section style="width: 32.5%;">
					<p>備考</p>
					<input class="textbox" type="text" v-model="biko1" name="biko1" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
					<input class="textbox" type="text" v-model="biko2" name="biko2" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
					<input class="textbox" type="text" v-model="biko3" name="biko3" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
					<input class="textbox" type="text" v-model="biko4" name="biko4" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
				</section>

				<section style="width: 32.5%; padding-right:0px;">
					<p>摘要</p>
					<input class="textbox" type="text" v-model="tekiyo" name="tekiyo" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
					<br />
					<p>コメント</p>
					<input class="textbox" type="text" v-model="annotation" name="annotation" id="textInput" style="width: 100%; ime-mode: active;" v-bind:readonly="isReadOnly">
				</section>



			</container>

			<!-- 操作ボタン -->
			<container class="button-background">
				<div class="button-container">
					<button class="action-button" @click="editable" :disabled="!isReadOnly">
						編集
					</button>
					<button class="action-button" style="margin-right:50px;" @click="update" :disabled="isReadOnly || isStoreDB">
						登録
					</button>
					<v-icon @click="toggleLock" :disabled="isReadOnly">{{ !isLock ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
					<button class="action-button" @click="cancel" :disabled="isReadOnly || isLock">
						取消
					</button>
				</div>

				<div class="button-container">
					<button class="action-button" @click="goto_first" :disabled="!isReadOnly">
						先頭
					</button>
					<button class="action-button" @click="goto_before" :disabled="!isReadOnly">
						前
					</button>
					<button class="action-button" @click="goto_next" :disabled="!isReadOnly">
						次
					</button>
					<button class="action-button" @click="goto_last" :disabled="!isReadOnly">
						最後
					</button>
				</div>

				<div class="button-container">
					<button class="action-button" @click="goto_print" :disabled="!enablePrint">
						証明書印刷
					</button>
				</div>
			</container>
		</div>
		<!-- 操作・入力項目 ここまで -->

		<Dialog error :open="authDialog" :ok="() => authDialog = false" :to="'/'" title="ユーザー認証"
			body="ユーザー認証に失敗しました。ログインし直して下さい。" />
	</body>
</template>
  
<script>
//import MapComponent from '../components/Map.vue'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt, daichoIMG, 
	daichoURL, /*getWardCode, getWarekiCode,*/ /*getSyuyoCode,*/ /*getSyuyoName,*/
	getGutaiSyuyoYotoCode, getGutaiSyuyoYotoName, /*getKojiSybtCode,*/ /*getKojiSybtName,*/
	getWardCodeBalicsShortname, /*getKozoSybtCode,*/ /*getSyuyoName,*/ /*getKojiSybtName,*/ /*getKozoSybtName*/ } from '../common/utils'
import constants from '../common/constants'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'
import DatePicker from '../components/DatePickerWarekiText.vue'
//import DatePicker from '../components/DatePickerWareki.vue'
//import DatePicker from '../components/DatePicker.vue'

export default {
	data() {
		return {
			scalevisible: false,
			existsGaiyo: false,
			plotUrl: '',
			plotUrlAlt: '',
			plotDef: null,
			plotDefAlt: null,
			sheetUrl: '',
			nendoList: [],
			bgmapList: [],
			queryingSheet: false,
			nendoCols: 12,
			nendoXlCols: 6,
			textClass: 'text-h6',
			targetPlotData: this.targetPlot,
			selectedLayer: '',
			// swipe用変数
			position: 0,
			moveX: 0,
			width: 0,
			authDialog: false,
			unit_site_area: 'option1',
			unit_bld_area: 'option1',

			//------------------------------------
			// 2023/12/26
			// 値を表示
			flg_kakutei: "",
			sikibetsu: "",
			flg_data_kakutei: "",
			flg_data_kknnzumi: "",
			uke_day: "",
			kknn_day: "",
			bldr_addr1: "",
			bldr_addr2: "",
			bldr_name1: "",
			bldr_name2: "",
			bldr_other_cnt: "",
			bkn_addr1: "",
			bkn_addr2: "",
			syuyo_yoto: "",
			bkn_sybt: "",
			koji_sybt: "",
			kozo_sybt: "",
			tijo_kaisu: "",
			tika_kaisu: "",
			sns_bld_su: "",
			site_area: "",
			bld_area: "",
			nb_area: "",
			unit_nb_area: "",
			kenzumi_day: "",
			flg_kenzumi: "",
			stop_sybt: "",
			stop_day: "",
			biko1: "",
			biko2: "",
			biko3: "",
			biko4: "",
			tekiyo: "",
			annotation: "",
			currentFileName: "", 

			// 画像表示URL
			imageUrl: "",
			rotationAngle: 0,

			isReadOnly: true,
			isStoreDB: false,
			isLock: true,
			//------------------------------------

			//------------------------------------
			// Zoom
			isDragging: false,
			startX: 0,
			startY: 0,
			translateX: 0,
			translateY: 0,
			scale: 1,
			//------------------------------------
			isShiDaicho: false,
			isKuDancho: false,
			iskeiDaicho: false,
			isBunDaicho: false,
			isGaiyosho: false,
			selectedDataBook: "getFirstSelect",

			isBeforeImage: false,
			isNextImage: false,
			

			enablePrint: true,
		}
	},
	components: {
		//    MapComponent,
		DatePicker,
		Dialog,
	},
	props: {
		zoom: {
			type: Number,
			default: 18,
		},
		targetPlot: {
			type: Object,
			default: null,
		},
	},
	created() {
		this.plotUrl = plotUrl();
		this.plotUrlAlt = plotUrlAlt();
		this.plotDef = constants.tileDef[this.mode];
		if (this.mode == 5) {
			this.plotDefAlt = constants.tileDef[6];
		}
		dbglog('MapPane:' + this.plotDef);
		if (this.sheetVisible) {
			if (this.mode == 1) {
				this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
			}
			else if (this.mode == 5) {
				this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
			}
		}
		if (this.mode == 7) {
			///*
			this.bgmapList = [
				this.$store.state.mapOrigin + constants.tileDef[10].url,
				this.$store.state.mapOrigin + constants.tileDef[11].url,
			];
			//*/
			/*
			this.bgmapList = [];
			if (this.$store.state.seibiSokushinVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
			}
			if (this.$store.state.douroShubetsuVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
			}
			*/
		}
	},
	mounted() {
		if (this.unauthorized) {
			this.message = 'ユーザー認証されていません。';
			this.$router.replace('/');
		}
		this.$store.commit('setCurrentPage', 5);
		this.message = '';
		//選択されているプロットの番号が保存されている場合
		if (this.selectedNo) {
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		}

		//------------------------------------
		// 2023/12/26
		// 値を表示
		this.dispItemData();
		this.setReadOnly(true);
		this.shouldDisableButton();
		//------------------------------------


		//this.targetPlotData = this.targetPlot; //ここでは遅い
		//test
		//console.log(this.targetPlot);
	},
	computed: {
		token() {
			return this.$store.state.token;
		},
		unauthorized() {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized() {
			return !this.unauthorized;
		},
		message: {
			get() { return this.$store.state.message; },
			set(val) { this.$store.commit('setMessage', val); }
		},
		browsable() {
			return this.isSelected && this.existsGaiyo;
		},
		features: {
			get() { return this.$store.state.features; },
			set(val) { this.$store.commit('setFeatures', val); }
		},
		sheets: {
			get() { return this.$store.state.sheets; }
		},
		mode() {
			return this.$store.state.mode;
		},
		authority() {
			//return this.$store.state.authority;
			return this.$store.state.userInfo.authority;
		},
		sheetVisible() {
			//return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
			// authority=4 は住所検索と番号検索のみ（仮）
			return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
		},
		douroShubetsuVisible: {
			get() {
				return this.$store.state.douroShubetsuVisible;
			},
			set(val) {
				this.$router.commit('setDouroShubetsuVisible', val);
			}
		},
		gaiyoId() {
			return this.$store.state.gaiyoId;
		},
		gaiyo() {
			return this.$store.state.gaiyoData;
		},
		selectedNo: {
			get() { return this.$store.state.selectedNo; },
			set(val) { this.$store.commit('setSelectedNo', val); }
		},
		selectedId: {
			get() { return this.$store.state.selectedId; },
			set(val) { this.$store.commit('setSelectedId', val); }
		},
		gaiyoList() {
			return this.$store.state.gaiyoList;
		},
		centerx() {
			return this.$store.state.centerx;
		},
		centery() {
			return this.$store.state.centery;
		},
		selectedPlotTitle() {
			let title = this.plotDef.title;
			if (this.plotDefAlt)
				title += '・' + this.plotDefAlt.title;
			return title;
		},
		browseButtonTitle() {
			if (this.mode == 1) {
				return '概要書を閲覧';
			}
			else if (this.mode == 2) {
				return '昇降機台帳を閲覧';
			}
			else if (this.mode == 3) {
				return '定期報告概要書を閲覧';
			}
			else if (this.mode == 5) {
				if (this.selectedLayer == 'vectorLayer')
					return '開発登録簿を閲覧';
				else if (this.selectedLayer == 'vectorLayerAlt')
					return '造成計画平面図を閲覧';
				else
					return '閲覧';
			}
			else {
				return '閲覧';
			}
		},
		isSelected() {
			return this.selectedNo !== undefined && this.selectedNo !== null
				&& this.selectedNo != '';
		},
		wardCode() {
			return this.$store.state.wardCode;
		},
		wardName() {
			return this.$store.state.wardName;
		},
		townCode() {
			return this.$store.state.townCode;
		},
		townName() {
			return this.$store.state.townName;
		},
		oyaban() {
			return this.$store.state.oyaban;
		},
		edaban() {
			return this.$store.state.edaban;
		},
		bottomSheet() {
			return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
		}
	},
	watch: {
		features(newValue, oldValue) {
			dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
			if (newValue != null) {
				if (newValue.length == 0 || newValue.length > 1) {
					this.selectedId = '';
					this.selectedNo = '';
					this.selectedLayer = '';
				}
				else if (newValue.length == 1) {
					this.selectRow(newValue[0]);
				}
			}
		},
		sheets(newValue, oldValue) {
			if ((newValue != oldValue) && !this.queryingSheet) {
				const ku = this.wardCode - 14100;
				let sheets = '';
				for (let i = 0; i < newValue.length; i++) {
					sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
				}
				let url = '';
				if (this.mode == 1) {
					url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else if (this.mode == 5) {
					url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else {
					return;
				}
				this.queryingSheet = true;
				callGetApi(url, (data) => {
					this.nendoList = [];
					if (data.length) {
						if (data.length > 10) {
							this.nendoCols = 6;
							this.nendoXlCols = 4;
							this.textClass = 'text-h7';
						}
						else {
							this.nendoCols = 12;
							this.nendoXlCols = 6;
							this.textClass = 'text-h6';
						}
						for (let i = 0; i < data.length; i++) {
							for (let j = 0; j < newValue.length; j++) {
								if (data[i].id == newValue[j].indexId) {
									this.nendoList.push({
										id: data[i].id,
										name: data[i].name,
										pageNo: newValue[j].pageNo,
										branch: newValue[j].branch
									});
									break;
								}
							}
						}
					}
					this.queryingSheet = false;
				});
			}
		},
		uke_day(newValue, oldValue) {
			if(newValue !== oldValue) {
						const datePickerInstance = this.$refs.cnfUkeDate;
						datePickerInstance.pickerText = newValue;
			datePickerInstance.inputDate();
			}
		},
		kknn_day(newValue, oldValue) {
			if(newValue !== oldValue) {
						const datePickerInstance = this.$refs.cnfKknnnDate;
						datePickerInstance.pickerText = newValue;
			datePickerInstance.inputDate();
			}
		},
		kenzumi_day(newValue, oldValue) {
			if(newValue !== oldValue) {
						const datePickerInstance = this.$refs.cnfKenzumiDate;
						datePickerInstance.pickerText = newValue;
			datePickerInstance.inputDate();
			}
		},
		stop_day(newValue, oldValue) {
			if(newValue !== oldValue) {
						const datePickerInstance = this.$refs.cnfStopDate;
						datePickerInstance.pickerText = newValue;
			datePickerInstance.inputDate();
			}
		},
		// データ確定識別がfalseになった場合、データ確認済識別もfalseに設定
		flg_data_kakutei(newValue, oldValue) {
			if (!newValue) {
				this.flg_data_kknnzumi = false;
			}
			if(newValue !== oldValue) {
				this.shouldDisableButton();
			}
		},
		stop_sybt(newValue, oldValue) {
			if(newValue !== oldValue) {
				this.shouldDisableButton();
			}
		},
	},
	methods: {
		shouldDisableButton() {
			//!flg_data_kknnzumi && !flg_data_kakutei || !isReadOnly || (stop_sybt != 0)
      // disabled 条件を計算する関数
			var check_kakutei = this.flg_data_kakutei;
			var check_readOnly = this.isReadOnly;
			var check_stop_sybt = false;
			if(this.stop_sybt) {
				check_stop_sybt = (parseInt(this.stop_sybt) !== 0);
			} 
//			var check_stop_sybt = this.stop_sybt;
//			console.log(">>>>>> shouldDisableButton");
//			console.log(check_kakutei);
//			console.log(check_readOnly);
//			console.log(check_stop_sybt);
			this.enablePrint  = true;
			if(!check_readOnly) {
				this.enablePrint  = false;
			} else {
				if(check_stop_sybt) 
					this.enablePrint  = false;
				if(!check_kakutei) 
					this.enablePrint  = false;
			}
//			console.log(this.enablePrint);
    },
		getImageURL() {
			//var sel_mode = this.$store.state.seldaichoImageMode;
			var sel_index = this.$store.state.seldaichoImageIndex;
			var data = this.$store.state.daichoImage[sel_index];

			var folder = data.folder;
			var file_name = data.file_name.replace(".tif", '.png');
			var url = "";
			if(folder == ""){
				return url;
			}

			console.log('####### getImageURL');
			if(data.uke_kubun == 5){
				folder = folder.replace(/\\/g, "/");
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.daichoOrigin + `${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			} else {
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.mapOrigin + `daicho/${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			}
			console.log(url);

      this.currentFileName = file_name;
			return url;
		},
		printImage() {
			const url = this.getImageURL();
			const rotationAngle = this.rotationAngle;

			var printFrame = document.createElement('iframe');
			printFrame.style.display = 'none';

			printFrame.onload = function() {
				var imageContainer = printFrame.contentDocument.querySelector('div');
        imageContainer.style.display = 'flex';
        imageContainer.style.margin = 0;
        imageContainer.style.justifyContent = 'center';
        imageContainer.style.alignItems = 'center';
        imageContainer.style.height = '100vh';
        //imageContainer.style.width = '100%';
        //imageContainer.style.height = '100%';

				//var style = printFrame.contentDocument.createElement('style');
				//style.innerHTML = '@media print { @page { size: landscape; } }';
				//printFrame.contentDocument.head.appendChild(style);

				var image = printFrame.contentDocument.querySelector('img');
				image.style.maxWidth = '100%';
        image.style.maxHeight = '100%';
        image.style.transform = `rotate(${rotationAngle}deg)`;
//		一時的に追加
				printFrame.contentWindow.print();
				document.body.removeChild(printFrame);
			};

			document.body.appendChild(printFrame);

			printFrame.contentDocument.write('<html><head><title>Print Image</title></head><body style="margin: 0; text-align: center;"><div><img src="' + url + '" style="max-width: 100%; max-height: 100%;"></div></body></html>');
			printFrame.contentDocument.close();

			// ページ読み込み完了後に印刷を開始します
	//		一時的に876行目に追加
	//		printFrame.contentWindow.print();
	//		document.body.removeChild(printFrame);
		},
		rotateRight() {
		this.rotationAngle += 90;
		this.rotateImage();
		},
		rotateLeft() {
		this.rotationAngle -= 90;
		this.rotateImage();
		},
		rotateImage() {
		const image = this.$refs.image;
				//const wrapper = image.parentElement;

				//this.adjustImageSize(image, wrapper);
		image.style.transform = `rotate(${this.rotationAngle}deg)`;
		},
		adjustImageSize(image, wrapper) {
		if (this.rotationAngle % 180 === 90) {
			wrapper.style.width = `${image.clientHeight}px`;
			wrapper.style.height = `${image.clientWidth}px`;
		} else {
			wrapper.style.width = '';
			wrapper.style.height = '';
		}
		},
		toggleFullScreen() {
			let newWindow = window.open('', '_blank');
			let url = this.$router.resolve({ name: "Kamidispimage" }).href+"?image="+this.imageUrl;
			newWindow.location.href = url;
		},
		goto_first() {
			var sel_index = 0;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_before() {
			var sel_index = this.$store.state.seldaichoIndex - 1;
			if (sel_index < 0) sel_index = 0;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_next() {
			var daicho_list = this.$store.state.daicho;
			var sel_index = this.$store.state.seldaichoIndex + 1;
			if (sel_index >= daicho_list.length) sel_index = daicho_list.length - 1;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_last() {
			var daicho_list = this.$store.state.daicho;
			var sel_index = sel_index = daicho_list.length - 1;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_print() {
			this.$router.push('kamisearchresultprint');
		},
		makeImagePostData(item, uke_kubun) {
			console.log(item);
			var postData = {};
//			var daicho_search = this.$store.state.daichoSearch;

			postData.uke_kubun = uke_kubun;
			//postData.id = item.id;
			postData.uke_day = item.uke_day;
//			postData.gengo = getWarekiCode(daicho_search.gengo);
//			postData.nen = daicho_search.nen;
//			postData.nen_kubun = daicho_search.nen_kubun;
//			postData.gyosei_kubun = getWardCode(daicho_search.gyosei_kubun);
//			postData.bango = daicho_search.bango;
//			postData.branch = daicho_search.branch;

			postData.gengo = item.gengo;
			postData.nen = item.nen;
			postData.nen_kubun = item.nen_kubun;
			postData.gyosei_kubun = item.gyosei_kubun;
			postData.bango = item.bango;
			postData.branch = item.branch;

			return (postData);
		},
		makePostData() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];

			var postData = {};

			//postData.id = daicho_item.id.trim();
			postData.id = daicho_item.id;
			this.flg_kakutei = 0;
			if(this.flg_data_kakutei == true) {
				this.flg_kakutei = 1;
			}
			daicho_item.flg_kakutei = postData.flg_kakutei = this.flg_kakutei;
			daicho_item.data_kakutei = postData.data_kakutei = this.flg_data_kakutei;
			daicho_item.uke_day = postData.uke_day = this.uke_day;
			daicho_item.kknn_day = postData.kknn_day = this.kknn_day;
			daicho_item.bldr_addr1 = postData.bldr_addr1 = this.bldr_addr1;
			daicho_item.bldr_addr2 = postData.bldr_addr2 = this.bldr_addr2;
			daicho_item.bldr_name1 = postData.bldr_name1 = this.bldr_name1;
			daicho_item.bldr_name2 = postData.bldr_name2 = this.bldr_name2;
			daicho_item.bldr_other_cnt = postData.bldr_other_cnt = this.bldr_other_cnt;
			daicho_item.bkn_addr1 = postData.bkn_addr1 = this.bkn_addr1;
			daicho_item.bkn_addr2 = postData.bkn_addr2 = this.bkn_addr2;
//			daicho_item.gutai_syuyo_yoto = postData.gutai_syuyo_yoto = getSyuyoName(this.syuyo_yoto);
			daicho_item.gutai_syuyo_yoto = postData.gutai_syuyo_yoto = this.syuyo_yoto;
			daicho_item.bkn_sybt = postData.bkn_sybt = getGutaiSyuyoYotoCode(this.bkn_sybt);
			daicho_item.gutai_koji_sybt = postData.gutai_koji_sybt = this.koji_sybt;
			daicho_item.gutai_kozo_sybt = postData.gutai_kozo_sybt = this.kozo_sybt;
//			daicho_item.kozo_sybt = postData.kozo_sybt = this.kozo_sybt;
			daicho_item.tijo_kaisu = postData.tijo_kaisu = this.tijo_kaisu;
			daicho_item.tika_kaisu = postData.tika_kaisu = this.tika_kaisu;
			daicho_item.sns_bld_su = postData.sns_bld_su = this.sns_bld_su;
			daicho_item.site_area = postData.site_area = this.site_area;
			daicho_item.unit_site_area = postData.unit_site_area = this.unit_site_area;
			daicho_item.bld_area = postData.bld_area = this.bld_area;
			daicho_item.unit_bld_area = postData.unit_bld_area = this.unit_bld_area;
			daicho_item.nb_area = postData.nb_area = this.nb_area;
			daicho_item.unit_nb_area = postData.unit_nb_area = this.unit_nb_area;
			if(this.flg_kenzumi) {
				daicho_item.flg_kenzumi = postData.flg_kenzumi = 1;
				this.kenzumi_day = "";
			}else{
				daicho_item.flg_kenzumi = postData.flg_kenzumi = 0;
			}
			daicho_item.kenzumi_day = postData.kenzumi_day = this.kenzumi_day;
			daicho_item.stop_sybt = postData.stop_sybt = this.stop_sybt;
			daicho_item.stop_day = postData.stop_day = this.stop_day;
			daicho_item.biko1 = postData.biko1 = this.biko1;
			daicho_item.biko2 = postData.biko2 = this.biko2;
			daicho_item.biko3 = postData.biko3 = this.biko3;
			daicho_item.biko4 = postData.biko4 = this.biko4;
			daicho_item.tekiyo = postData.tekiyo = this.tekiyo;
			daicho_item.annotation = postData.annotation = this.annotation;
			if(this.flg_data_kknnzumi) {
				daicho_item.data_kknnzumi = postData.data_kknnzumi = 1;
			}else{
				daicho_item.data_kknnzumi = postData.data_kknnzumi = 0;
			}

			return (postData);
		},
		setPrintNextBeforeButton() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex;
			var sel_mode = this.$store.state.seldaichoImageMode;

			var min_v = 100;
			var max_v = -1;
			for (var i = 0; i < daicho_list.length; i++) {
				if(daicho_list[i].uke_kubun == sel_mode){
					if(min_v > i) min_v = i;
					if(max_v < i) max_v = i;
				}
			}
			if (sel_index <= min_v) {
				this.isBeforeImage = false;
			}else {
				this.isBeforeImage = true;
			}
			if(sel_index < max_v) {
				this.isNextImage = true;
			}else{
				this.isNextImage = false;
			}
		},
		goto_before_image() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex - 1;
			var sel_mode = this.$store.state.seldaichoImageMode;

			for (var i = sel_index; i >= 0; i--) {
				if(daicho_list[i].uke_kubun == sel_mode){
					sel_index = i;
					break;
				}
			}

			this.$store.commit('setDaichoimageindex', sel_index);
			this.setPrintNextBeforeButton();
			this.dispImageData();
		},
		goto_next_image() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex + 1;
			var sel_mode = this.$store.state.seldaichoImageMode;

			for (var i = sel_index; i < daicho_list.length; i++) {
				if(daicho_list[i].uke_kubun == sel_mode){
					sel_index = i;
					break;
				}
			}

			this.$store.commit('setDaichoimageindex', sel_index);
			this.setPrintNextBeforeButton();
			this.dispImageData();
		},
		dispImageData() {
			const url = this.getImageURL();
			if(url != ""){
				this.imageUrl = url;
			}
		},
		checkImageExists(data) {
			var url = "";
			var folder = data.folder;
			var file_name = data.file_name.replace(".tif", '.png');

			console.log('####### checkImageExists');
			if(data.uke_kubun == 5){
				folder = folder.replace(/\\/g, "/");
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.daichoOrigin + `${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			} else {
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.mapOrigin + `daicho/${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			}

			var http = new XMLHttpRequest();
			http.open('HEAD', url, false); // 同期的なリクエストを行う
			http.send();
			//return http.status === 200 && http.getResponseHeader('Content-Type').indexOf('image') !== -1;
			return http.status === 200;
		},
		getImageData(daicho_item, uke_kubun) {
			// 画像表示
			var value = this.makeImagePostData(daicho_item, uke_kubun);
			console.log(value);

			var url = daichoIMG() + `/Search`;
			fetch(url, {
				mode: 'cors',
//				method: 'GET',
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(value)
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					} else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					console.log(data);
					var uke_kubun = 0;
					for (var i = 0; i < data.length; i++) {
						if(data[i].uke_kubun == 1){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isShiDaicho = true;
								if(uke_kubun == 0) uke_kubun = 1;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 2){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isKuDancho = true;
								if(uke_kubun == 0) uke_kubun = 2;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 3){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.iskeiDaicho = true;
								if(uke_kubun == 0) uke_kubun = 3;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 4){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isBunDaicho = true;
								if(uke_kubun == 0) uke_kubun = 4;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 5){
							var copy_obj = null;
							data[i].file_name = data[i].file_name.replace('.tif', '-0.png');
							var orig_copy_obj = Object.assign({}, data[i]);
							if(this.checkImageExists(data[i])) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}

							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-1.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-2.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-3.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-4.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-5.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							break;
						}
					}

					this.$store.commit('setDaichoimage', data);
					this.$store.commit('setDaichoimageindex', 0);
					this.$store.commit('setDaichoimageMode', uke_kubun);
					this.setPrintNextBeforeButton();
					this.dispImageData();
					this.selectedDataBook = this.getFirstSelect();
				})
				.catch((err) => {
					dbglog(`Address.vue.searchChiban(): ${err}`);
				});
		},
		async setReadOnly(flag) {
			this.isReadOnly = flag;
			this.shouldDisableButton();
		},
		async editable() {
			await this.$nextTick();

			this.setReadOnly(false);
			//this.$refs.bldr_addr1.focus();
//			this.$refs.cnfUkeDate.focus();
			setTimeout(() => {
        this.$refs.cnfUkeDate.focus();
			}, 500);
//			this.$nextTick(() => {
//			this.$refs.cnfUkeDate.focus(); });
		},
		cancel() {
			this.dispItemData();
			this.setReadOnly(true);
		},
		setValue(value) {
			return value !== null ? value : '-';
		},
		dispKubunImageData(uke_kubun) {
			this.rotationAngle = 0;
			this.isDragging = false;
			this.startX = 0;
			this.startY = 0;
			this.translateX = 0;
			this.translateY = 0;
			this.scale = 1;
			this.rotateImage();

			var daicho_list = this.$store.state.daichoImage;
			var sel_index = 0;
			var sel_mode = uke_kubun;

			for (var i = 0; i < daicho_list.length; i++) {
				if(daicho_list[i].uke_kubun == sel_mode){
					sel_index = i;
					break;
				}
			}

			this.$store.commit('setDaichoimageMode', uke_kubun);
			this.$store.commit('setDaichoimageindex', sel_index);

			this.setPrintNextBeforeButton();
			this.dispImageData();
		},
		dispItemData() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];
			console.log(daicho_item);

			this.sikibetsu = daicho_item.nen +getWardCodeBalicsShortname(daicho_item.gyosei_kubun)+ daicho_item.bango;
			this.flg_kakutei = daicho_item.flg_kakutei;
			this.flg_data_kakutei = false;
			if(daicho_item.flg_kakutei == 1) {
				this.flg_data_kakutei = true;
			}
			try{
				this.uke_day = daicho_item.uke_day.split('T')[0];
			}catch(e){
				this.uke_day = "";
			}
			try{
				this.kknn_day = daicho_item.kknn_day.split('T')[0];
			}catch(e){
				this.kknn_day = "";
			}
			this.bldr_addr1 = daicho_item.bldr_addr1;
			this.bldr_addr2 = daicho_item.bldr_addr2;
			this.bldr_name1 = daicho_item.bldr_name1;
			this.bldr_name2 = daicho_item.bldr_name2;
			this.bldr_other_cnt = daicho_item.bldr_other_cnt;
			this.bkn_addr1 = daicho_item.bkn_addr1;
			this.bkn_addr2 = daicho_item.bkn_addr2;
//			this.syuyo_yoto = getSyuyoCode(daicho_item.gutai_syuyo_yoto);
			this.syuyo_yoto = daicho_item.gutai_syuyo_yoto;
			this.bkn_sybt = getGutaiSyuyoYotoName(daicho_item.bkn_sybt);
			this.koji_sybt = daicho_item.gutai_koji_sybt;
			this.kozo_sybt = daicho_item.gutai_kozo_sybt;
			this.tijo_kaisu = this.setValue(daicho_item.tijo_kaisu);
			this.tika_kaisu = this.setValue(daicho_item.tika_kaisu);
			this.sns_bld_su = this.setValue(daicho_item.sns_bld_su);
			this.site_area = this.setValue(daicho_item.site_area);
			this.unit_site_area = daicho_item.unit_site_area;
			this.bld_area = this.setValue(daicho_item.bld_area);
			this.unit_bld_area = daicho_item.unit_bld_area;
			this.nb_area = this.setValue(daicho_item.nb_area);
			this.unit_nb_area = daicho_item.unit_nb_area;
			try{
				this.kenzumi_day = daicho_item.kenzumi_day.split('T')[0];
			}catch(e){
				this.kenzumi_day = "";
			}
			if(daicho_item.flg_kenzumi == 1) {
				this.flg_kenzumi = true;
				this.kenzumi_day = "";
			}else{
				this.flg_kenzumi = false;
			}
			this.stop_sybt = daicho_item.stop_sybt;
			try{
				this.stop_day = daicho_item.stop_day.split('T')[0];
			}catch(e){
				this.stop_day = "";
			}
			this.biko1 = daicho_item.biko1;
			this.biko2 = daicho_item.biko2;
			this.biko3 = daicho_item.biko3;
			this.biko4 = daicho_item.biko4;
			this.tekiyo = daicho_item.tekiyo;
			this.annotation = daicho_item.annotation;
//			if (daicho_item.annotation !== null && daicho_item.annotation.indexOf("確認済") !== -1) {
//				daicho_item.data_kknnzumi = true
//			}
			//this.flg_data_kknnzumi = daicho_item.data_kknnzumi;
			if(daicho_item.data_kknnzumi) {
				this.flg_data_kakutei = true;
				daicho_item.flg_kakutei = 1;
				this.flg_data_kknnzumi = true;
			}else{
				this.flg_data_kknnzumi = false;
			}

			// 画像表示
			this.getImageData(daicho_item,null);
		},
		check_input_data_block() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];

			var targetDate = new Date(this.uke_day);
			var year = 0;
			var min = null;
			var max = null;

			//【受付日】
			if(daicho_item.gengo == 3) {
				if(daicho_item.nen <= 34) {
					//	受付日が1/1~12/31であること（昭和34年度まで）
					year = daicho_item.nen + 1925;
					//year = targetDate.();
					min = new Date(year, 0, 1); //月は0スタート
					max = new Date(year+1, 0, 1); //月は0スタート

					if (targetDate > max || targetDate < min) {
						return '受付日が1/1~12/31であること（昭和34年度まで）';
					}
				} else if(daicho_item.nen == 35) {
					//	受付日が1/1～昭和36年3月31日であること（昭和35年）
					year = daicho_item.nen + 1925;
					//year = targetDate.getFullYear();
					min = new Date(year, 0, 1); //月は0スタート
					max = new Date(year+1, 3, 1); //月は0スタート

					if (targetDate > max || targetDate < min) {
						return '受付日が1/1～昭和36年3月31日であること（昭和35年）';
					}
				} else if(daicho_item.nen >= 36) {
					//	受付日が4/1~3/31であること（昭和36年度以降）
					year = daicho_item.nen + 1925;
					//year = targetDate.getFullYear();
					min = new Date(year, 3, 1); //月は0スタート
					max = new Date(year+1, 3, 1); //月は0スタート

					if (targetDate > max || targetDate < min) {
						return '受付日が4/1~3/31であること（昭和36年度以降）';
					}
				}
			} else if (daicho_item.gengo == 4) {
				if (year == 1989) {
					//	平成元年1/8~3/31の入力を許可する
					year = daicho_item.nen + 1988;
					//year = targetDate.getFullYear();
					min = new Date(year, 0, 8); //月は0スタート
					max = new Date(year+1, 3, 1); //月は0スタート

				} else {
				//	受付日が4/1~3/31であること（平成）
				year = daicho_item.nen + 1988;
				//year = targetDate.getFullYear();
				min = new Date(year, 3, 1); //月は0スタート
				max = new Date(year+1, 3, 1); //月は0スタート

					if (targetDate > max || targetDate < min) {
							return '受付日が4/1~3/31であること（平成）';
					}
				}
			}

				//flg_kenzumiにチェックない場合の分岐
				
				//【確認日】
				//	確認日が受付日より前でないこと
				/*
				var uke_day = null;
				var kknn_day = null;
				var kenzumi_day = null;
				if((this.kknn_day ?? null) && (this.uke_day ?? null)) {
					uke_day = new Date(this.uke_day);
					kknn_day = new Date(this.kknn_day);
					if(uke_day > kknn_day) {
						return '受付日 > 確認日';
					}		
				}	

				//【検査済証交付年月日 】
				//	検査済証交付日が確認日より後の日付であること
				if((this.kknn_day ?? null) && (this.kenzumi_day ?? null)) {
					kknn_day = new Date(this.kknn_day);
					kenzumi_day = new Date(this.kenzumi_day);
					if(kknn_day > kenzumi_day) {
						return '検査済証交付年月日 > 確認日月日';
					}		
				}
				
				//	検査済証交付日が入力されているか「記載なし」にチェック
				if(!((this.flg_kenzumi == true) || (this.kenzumi_day))) {
					return '検査済証交付日が入力されているか「記載なし」にチェック';
				*/

			var kknn_day = null;
			var kenzumi_day = null;
			
			if ((!this.flg_kenzumi) && (!this.kenzumi_day)) {
				return '検査済証交付日が入力されているか「記載なし」にチェック';
			}	
			if ((!this.flg_kenzumi) && (this.kenzumi_day)) {
				if((this.kknn_day) && (this.kenzumi_day)) {
					kknn_day = new Date(this.kknn_day);
					kenzumi_day = new Date(this.kenzumi_day);
					if(kknn_day > kenzumi_day) {
						return '検査済証交付年月日 > 確認日月日';
					}		
				}
			}	
			if (this.flg_kenzumi) {
				this.kenzumi_day = null;
			}
			return '';
		},

		check_input_data() {
			//【確認日】
			//	確認日が受付日より前でないこと
			var uke_day = null;
			var kknn_day = null;
			if((this.kknn_day ?? null) && (this.uke_day ?? null)) {
				uke_day = new Date(this.uke_day);
				kknn_day = new Date(this.kknn_day);
				if(uke_day > kknn_day) {
					return '受付日 > 確認日';
				}		
			}		

			//【確認日】
			//	確認日が受付日と3年以上離れている場合、アラートを出す→登録は可能
			var date1 = new Date(this.uke_day);
			var date2 = new Date(this.kknn_day);

			// 年数の計算
			var diffYears = date2.getFullYear() - date1.getFullYear();

			// date2の月と日がdate1より後かどうかを確認
			if (date2.getMonth() < date1.getMonth() || (date2.getMonth() === date1.getMonth() && date2.getDate() < date1.getDate())) {
					diffYears--;
			}

			// ３年以上離れているかをチェック
			if (diffYears >= 3) {
				return '確認日が受付日と3年以上離れている';
			}

			return '';
		},
		async update() {
			await this.$nextTick();

			var msg = this.check_input_data_block();
			if(msg != '') {
				alert(msg);
				return;
			}
			msg = this.check_input_data();
			if(msg != '') {
				alert(msg);
			}

			var value = this.makePostData();
			//const url = daichoURL() + `?ward=${ward}&town=${town}&hon=${hon}&eda=${eda}`;
			const url = daichoURL() + `/Update`;
			dbglog(url);
			//this.isStoreDB = true;
			this.setReadOnly(true);
			fetch(url, {
				mode: 'cors',
//				method: 'GET',
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(value)
			})
				.then((response) => {
					dbglog(response);
					this.isStoreDB = false;
					//this.setReadOnly(true);
				})
				.catch((err) => {
					dbglog(`Address.vue.searchChiban(): ${err}`);
					this.isStoreDB = false;
					this.setReadOnly(true);
				});
		},
		floorInput(field) {
			this.convertToHalfWidth(field);
			this.validateInput(field);
		},
		convertToHalfWidth(field) {
			this[field] = this[field].replace(/[０-９]/g, function (s) {
				return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);

			});
		},
		validateInput(field) {
			this[field] = this[field].replace(/[^0-9-]/g, '');
		},

		floorEreaInput(field) {
			this.convertToHalfWidth2(field);
			this.validateInput2(field);
		},
		convertToHalfWidth2(field) {
			this[field] = this[field].replace(/[０-９．]/g, function (s) {
				return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
			});
		},
		validateInput2(field) {
			// 小数点も許可する正規表現に変更
			this[field] = this[field].replace(/[^0-9\-.]/g, '');
		},

		plotKey(layerFeature) {
			const k = layerFeature.feature ?? layerFeature;
			let result = k.get(this.plotDef.key);
			if (this.plotDefAlt !== null) {
				//if (result === undefined || result === null || result.length === undefined || result.length == 0) {
				if (!result) {
					result = k.get(this.plotDefAlt.key);
				}
			}
			return result;
		},
		isSelectedRow(k) {
			//const layer = k.layer;
			const feature = k.feature;
			const no = this.plotKey(feature);
			//const selNo = this.selectedNo;
			const selNo = this.selectedId;
			const hit = (no == selNo)
			//console.log(`k:${no} sel:${selNo} hit:${hit}`)
			return hit;
		},
		plotLabel(k) {
			const layer = k.layer;
			const feature = k.feature;
			let result = '不明';
			if (layer == 'vectorLayer') {
				result = feature.get(this.plotDef.label);
				if (!result)
					result = feature.get(this.plotDef.key);
			}
			else if (layer == 'vectorLayerAlt') {
				result = feature.get(this.plotDefAlt.label);
				if (!result) {
					result = feature.get(this.plotDefAlt.key);
				}
			}
			return result ?? '';
		},
		setMessage() {
			if (this.targetPlot) {
				this.$store.commit('setMessage', '　');
			}
			else {
				let addrText = `${this.wardName} ${this.townName}`;
				if (this.oyaban > 0) {
					addrText += ` ${this.oyaban}`;
					if (this.edaban > 0) {
						addrText += `-${this.edaban}`;
					}
				}
				this.$store.commit('setMessage', `地図検索：${addrText}`);
			}
		},
		// 呼び出される事がない？
		onMapSelectionChanged(selection) {
			//this.features = selection;
			//this.existsGaiyo = false;
			dbglog(`onMapSelectionChanged(${selection})`, -1);
			if (selection.length == 1) {
				dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
				this.selectRow(selection[0]);
			}
		},
		/**
		 * プロット一覧から特定の行を選択状態にする
		 * @param { PlotData } target 選択状態にするプロットデータ
		 */
		selectRow(target) {
			//test
			//this.targetPlotData = target.feature;
			//
			this.selectedLayer = target.layer;
			const selNo = this.plotKey(target);
			let selLabel = this.plotLabel(target);
			// 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
			//this.selectedNo = selNo;
			this.selectedId = selNo;
			this.selectedNo = selLabel;
			//開発・造成・土石の堆積の別を判定
			/*
			if (selNo != selLabel) {
				this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
			}
			*/
			this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
			// 選択された番号の概要書データが存在するか調べて
			// 閲覧ボタンの使用可否を設定する（建築のみ）
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		},
		selectNendo(nendo) {
			dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
			this.$store.commit('setIndexId', nendo.id);
			this.$store.commit('setNendoName', nendo.name);
			//プロット地図画面の入力値をクリア
			this.$store.commit('setSearchYear', 0);
			this.$store.commit('setSearchBango', '');
			//
			this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
		},
		/**
		 * 現在選択されているプロットの概要書を表示する
		 */
		browse() {
			this.$store.commit('setUkeNo', this.selectedNo);
			this.$store.commit('setGaiyoId', this.selectedId);
			this.$router.push({ name: 'loading', params: { action: 1 } });
		},
		/**
		 * 指定された受付番号のデータを検索する
		 * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
		 * @param {String} ukeNo 受付番号
		 */
		searchGaiyo(ukeNo, callback) {
			if (ukeNo == null || ukeNo.length == 0) {
				this.existsGaiyo = false; //暫定措置
				return;
			}
			this.existsGaiyo = true; //暫定措置

			let url;
			if (this.mode == 1) {
				url = gaiyoURL() + '?uke_no=' + ukeNo;
			}
			else if (this.mode == 2) {
				//url = elvUrl() +  '?uke_no=' + ukeNo;
				return;
			}
			else {
				return;
			}
			dbglog(url);

			fetch(url, {
				mode: 'cors',
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + this.token,
				},
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					}
					else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					if (data == 401) {
						this.loading = false;
						this.progressMessage = 'ユーザ認証に失敗しました。';
						this.authDialog = true;
						return;
					}
					callback(data);
				})
				.catch((err) => {
					dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
				});
		},
		onScroll(event) {
			//console.log(event.target.scrollTop);
			if (event.target.scrollTop == 200) {
				//console.log('in');
				document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			} else if (event.target.scrollTop == 0) {
				document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			}
		},
		touchUp() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '90%';
			}
		},
		touchDown() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '30%';
			}
		},
		//------------------------------------
		// Zoom
		handleMouseDown(event) {
			event.preventDefault();
			
			this.isDragging = true;
			this.startX = event.clientX - this.$refs.container.offsetLeft;
			this.startY = event.clientY - this.$refs.container.offsetTop;
		},
		handleMouseMove(event) {
			if (!this.isDragging) return;
			const offsetX = event.clientX - this.startX;
			const offsetY = event.clientY - this.startY;
			this.translateX += offsetX;
			this.translateY += offsetY;
			this.startX = event.clientX;
			this.startY = event.clientY;
			},
		handleMouseUp() {
			this.isDragging = false;
		},
		handleWheel(event) {
			const delta = Math.sign(event.deltaY);
			const scaleFactor = 0.1;
			this.scale -= (delta * scaleFactor);
			this.scale = Math.max(0.6, this.scale);
		},
		toggleLock() {
			this.isLock = !this.isLock;
		},
		getFirstSelect() {
			if (this.isShiDaicho) return "1";
			if (this.isKuDancho) return "2";
			if (this.iskeiDaicho) return "3";
			if (this.isBunDaicho) return "4";
			if (this.isGaiyosho) return "5";
			return ""; // デフォルト値（すべてがdisabledの場合）
		},
	}
}
</script>
  
<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";

body {
	align-items: flex-start;
	/* 左寄せに設定 */
	height: 100vh;
	/* 画面の高さいっぱいに広がるように */
	padding-left: 10px;
	padding-right: 10px;
	margin: 0;
	/* ボディのマージンをゼロに設定 */
	background-color: #E0E0E0;
	/* グレーの背景色 */
	white-space: nowrap;
	/* テキストを改行させないようにする */
	overflow: hidden;
	/* コンテンツがコンテナをはみ出た場合に隠す */
}

container {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	flex-direction: row;
	max-width: auto;
	margin-right: 5px;
	text-align: left;
	font-size: 14px;
}

.right-align-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-right: 5px;
}

section {
	display: flex;
	justify-content: space-between;
	/* または space-evenly を使用する */
	align-items: flex-start;
	/* 左寄せに設定 */
	flex-direction: column;
	max-width: auto;
	/* 任意の横幅に設定 */
	margin-right: 5px;
	text-align: auto;
	/* 左寄せに設定 */
	font-size: 14px;
}

p {
	background-color: #70d8e4;
	/* 任意の色を指定 */
	width: 100%;
	margin-bottom: 0px;
}

thead {
	background-color: rgb(56, 110, 155);
	color: mintcream;
}

.split {
	//height: 100%;
	height: calc(100% - 12px);
	padding: 6px 0;
}

.right-box {
	right: 0;
	width: 30%;
	//height: 100%;
	height: calc(100% - 24px);
	margin: 4px 0;
	overflow-y: auto;
	background-color: rgb(118, 164, 170);
}

.acceptButton {
	font-size: 2rem;
	padding: 0.5em 1.5em;
}

/*
  .selected {
	background-color: rgb(238, 255, 0);
  }
  */
#selected-plot {
	background-color: lightsteelblue;
	font-size: 1.25rem;
	width: 100%;
	margin: 0.5em 0;
	text-align: center;
}

::v-deep .v-bottom-sheet {
	height: 30%;
}

.v-dialog__content {
	z-index: 2 !important;
}

/* 操作部分 */
.button-background {
	width: 100%;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
}

.button-container {
	display: flex;
	justify-content: space-between;
	/* アイテムを横方向に左寄せに配置 */
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.button-container-right {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-left: auto;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.action-button {
	position: relative;
	background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
	color: #000000;
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	height: 30px;
	padding-left: 20px;
	/* 左側のpadding */
	padding-right: 20px;
	/* 右側のpadding */
	margin-right: 1px;
	/* 仕切りとの間隔 */
	margin-bottom: 0px;
	/* 下部の余白を解除 */
	display: inline-flex;
	/* インラインフレックスコンテナにする */
	align-items: center;
	/* 垂直方向に中央揃え */
	cursor: pointer;
}

.action-button[disabled] {
	background: linear-gradient(to bottom, #d1d1d1, #b1b1b1);
	color: #8c8c8c;
}

.action-button::after {
	content: "";
	position: absolute;
	top: 0;
	right: -2px;
	/* 仕切りの太さ */
	height: 100%;
	width: 2px;
	/* 仕切りの幅 */
	background-color: #7a7a7a;
	/* 仕切りの色 */
}

.action-button:hover {
	background-color: #7c7c7c;
	/* カーソルが乗った時の背景色 */
}

.right-slide {
	margin-left: auto;
}

/* テキストボックス */
.textbox {
	background-color: #ffffff;
	width: 100%;
	/* ボックスの幅 */
	height: 26px;
	padding: 5px;
	/* テキストとボックスの内側の余白 */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	border-radius: 3px;
	/* 角の丸み */
	font-size: 14px;
	/* テキストのサイズ */
	-moz-appearance: textfield;
}

.textbox:focus {
	border-color: #007bff;
	/* フォーカス時のボーダーの色 */
	outline: none;
	/* デフォルトのフォーカス時のアウトラインを無効にする */
}

.textbox[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.textbox::-webkit-outer-spin-button,
.textbox::-webkit-inner-spin-button {
	-webkit-appearance: none;
	/* ChromeやSafariでの矢印を非表示にする */
	margin: 0;
	/* 矢印があった場所の余白を取り除く */
}

/* プルダウン */
select {
	width: 100%;
	padding: 4px;
	/* セレクトボックス内のコンテンツと枠の間に余白を作る */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	background-color: white;
	/* セレクトボックスの背景色を白にする */
	cursor: pointer;
}

select[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.custom-select {
	position: relative;
	display: inline-block;
}

.custom-select select {
	min-width: 40px;
	width: 100%;
	padding: 5px;
	font-size: 14px;
	border: 1px solid #808080;
	border-radius: 3px;
	background-color: #fff;
	appearance: none;
	/* デフォルトの矢印を非表示にする */
}

.custom-select::after {
	content: '\25BC';
	/* 下向きの三角矢印のUnicode */
	font-size: 7px;
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	pointer-events: none;
	/* 矢印はクリックイベントを受けないようにする */
}


/* チェックボックス */
.checkbox {
	margin-right: 5px;
	transform: scale(1.5);
}

/* データ入力時の台帳参照ウィンドウ */

.image-wrapper {
  display: inline-block;
}

.full-width-image {
	width: 100%;
	height: 100%;
  height: auto;
  position: absolute;
	margin: 0 auto;
	object-fit: contain; /* 縦横比を保って表示 */
}

.fullscreen-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.fullscreen-content {
  text-align: center;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 100%;
}

.combob {
	min-width: 40px;
	width: 100%;
	padding: 5px;
	font-size: 14px;
	border: 1px solid #808080;
	border-radius: 3px;
	background-color: #fff;
	appearance: none;
	/* デフォルトの矢印を非表示にする */
}

.combob::after {
	content: '\25BC';
	/* 下向きの三角矢印のUnicode */
	font-size: 7px;
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	pointer-events: none;
	/* 矢印はクリックイベントを受けないようにする */
}

.scroll-container {
  overflow: hidden;
  width: 500px; /* 画像の初期幅 */
  height: 400px; /* 画像の初期高さ */
  border: 1px solid #808080;
  position: relative;
}
.image-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  transition: transform 0.3s ease; /* スムーズな移動を追加 */
}
.full-width-image {
  display: block;
  width: 100%;
  height: auto;
  cursor: grab; /* ドラッグカーソル */
}
label {
  cursor: pointer;
}





/* ラジオボタン項目 */
.input-hidden {
  visibility: hidden;
  position: absolute;
}

.input-hidden:checked + .action-button {
  background: linear-gradient(to bottom, #949494, #a3a3a3); 
  color: #000000;
}
</style>
  
